import * as React from 'react'
import { Renderer } from '../../components'
import { useFormContext } from 'react-hook-form'
import Map from './Map'
import * as Number from '@avcan/utils/number'
import styles from './GeoLocation.module.css'

export default function GeoLocation({ props }) {
    const { name, items } = props
    const { watch, setValue } = useFormContext()
    const value = useValues(watch(name, {}))
    const handleChange = React.useCallback(
        value => {
            setValue(name, value)
        },
        [setValue, name]
    )

    return (
        <React.Fragment>
            <div className={styles.ControlSet}>
                <Renderer items={items} />
            </div>
            <Map value={value} onChange={handleChange} />
        </React.Fragment>
    )
}

// Utils
function useValues(values) {
    return React.useMemo(() => formatValues(values), [values])
}

function formatValues(values) {
    return Object.fromEntries(
        Object.entries(values).map(([name, value]) => [name, Number.fromString(value)])
    )
}
